import { render, staticRenderFns } from "./select-criterion.vue?vue&type=template&id=51beb092"
import script from "./select-criterion.ts?vue&type=script&lang=js&external"
export * from "./select-criterion.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
